import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type MenuItem = {
  title: string;
  link: string;
  adminOnly: boolean;
  isComingSoon: boolean;
  isLocked: boolean;
  items: MenuItem[];
};

export type ManagementMenuResponse = MenuItem[];

export const managementMenuApiClient = {
  index: async (): Promise<ApiResult<ManagementMenuResponse>> => {
    return await axiosClient.get('/company/management-menus');
  },
};
